module.exports = __webpack_public_path__ + "static/media/home.27ab1623.svg";